import {IRouletteBet} from "./IRouletteBet";

export class ColumnBet implements IRouletteBet {
    constructor(public index: number, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/ColumnBet.ts